(function () {
    'use strict';
    var m = angular.module('app');
    m.controller('MainController', ["$scope", "widgetPolling", "modulesManager", "routeHelper", "$route", "sideMenuManager", "$timeout", "avananUserDao", "modals", "wizardHelper", "analytics", "linkedText", "errorStatusHolder", "policiesRefreshHelper", "configDao", "trialExpiredModal", "feature", "$templateCache", "path", "$location", "appConfigurator", "autologinHelper", "$rootScope", "brandInfo", "$q", "iframeMessagingService", function ($scope, widgetPolling, modulesManager, routeHelper, $route, sideMenuManager, $timeout, avananUserDao, modals, wizardHelper, analytics, linkedText, errorStatusHolder, policiesRefreshHelper, configDao, trialExpiredModal, feature, $templateCache, path, $location, appConfigurator, autologinHelper, $rootScope, brandInfo, $q, iframeMessagingService) {
        function htmlToPlaintext(text) {
            return text ? String(text).replace(/<[^>]+>/gm, '') : '';
        }
        /**
   *   in order to notify the iframe that navigation occured from parent, we pass a parentRouting parameter
   *   on the url received from angular
   */
        function isRoutingFromAvananParent(url) {
            return url.includes('parentRouting');
        }
        // checking if activated from the angular 8 app
        function inIframe() {
            return window.location !== window.parent.location & isRoutingFromAvananParent($location.url());
        }
        function main() {
            autologinHelper.init();
            $scope.isAuthenticated = false;
            $rootScope.pageVisitCount = 0;
            $rootScope.doLogout = false;
            $rootScope.errModalIsOn = false;
            $rootScope.enableMFAPopup = false;
            // TODO: please enable this variable when backend is capable for supporting MFA
            $q.all([feature.init(true, true)]).then(function () {
                feature.guiVersion = feature.guiVersion || window.guiVersion;
                if (feature.guiVersion == 2 && window.guiVersion !== 2) {
                    feature.guiVersion = undefined;
                    document.location = routeHelper.toV2Url();
                    return;
                } else if (feature.checkpointTheme) {
                    $('link[rel*=\'icon\']').attr('href', 'assets/common/images/favicon-checkpoint.ico');
                } else if (feature.lastlineTheme) {
                    $('link[rel*=\'icon\']').attr('href', 'assets/common/images/favicon-lastline.ico');
                } else if (feature.sonicwallTheme) {
                    $('link[rel*=\'icon\']').attr('href', 'assets/common/images/favicon-sonicwall.ico');
                    $scope.paramSpogSrc = autologinHelper.spogSrc();
                } else {
                    $('link[rel*=\'icon\']').attr('href', 'assets/common/images/favicon-avanan.ico');
                }
                var body = $('body');
                if (feature.guiVersion == 1) {
                    body.addClass('guiV1');
                } else if (feature.guiVersion == 2) {
                    body.addClass('guiV2');
                }
                if (feature.checkpointTheme) {
                    body.addClass('checkpoint-theme');
                }
                if (feature.lastlineTheme) {
                    body.addClass('lastline-theme');
                }
                if (feature.sonicwallTheme) {
                    body.addClass('sonicwall-theme');
                }
                if (feature.isDarkTheme) {
                    body.addClass('dark-theme');
                }
                body.addClass('loaded');
            });
            if (window.guiVersion != 1) {
                var linkedTextTemplateId = path('common').directive('linked-text').template();
                var template = $templateCache.get(linkedTextTemplateId);
                template = template.replace(/>\s+</g, '><');
                $templateCache.put(linkedTextTemplateId, template);
            }
            $scope.$on('$routeChangeSuccess', function (event, current) {
                $scope.isAuthenticated = $route.current && $route.current.$$route && $route.current.$$route.resolve && $route.current.$$route.resolve.currentUser;
                var url = $route.current.originalPath;
                _($route.current.params).each(function (val, key) {
                    if (key != 'id') {
                        url = url.split(':' + key).join(val);
                    }
                    // hideMenu
                    if (key == 'hide_menu' && val == '1') {
                        $rootScope.hideMenu = true;
                    }
                });
                analytics.pageView(url, htmlToPlaintext(linkedText.toText($route.current.title)));
                sideMenuManager.fullscreen($route.current.fullscreen || false);
                sideMenuManager.routeClass('route-' + $route.current.name);
                policiesRefreshHelper.clearPolicies();
                errorStatusHolder.errorStatus(null);
                var body = $('body');
                if ($route.current.hideMessenger) {
                    body.addClass('hide-messenger');
                } else {
                    body.removeClass('hide-messenger');
                }
                if (window.guiVersion === 2) {
                    var hasScroll = $route.current.scrollOnPage || false;
                    if (hasScroll) {
                        body.addClass('guiV2-scroll');
                    } else {
                        body.removeClass('guiV2-scroll');
                    }
                }
                $('html, body').animate({ scrollTop: 0 }, 'fast');
                widgetPolling.stopUpdating();
                if (!_(current.$$route).isUndefined() && current.$$route.name && current.$$route.name != 'auth' && current.$$route.name != 'authorize-error' && current.$$route.name != 'password-change') {
                    $('body').addClass('logged-in');
                    if (_(current.pathParams.module).isString()) {
                        modulesManager.currentModule(current.pathParams.module);
                    }
                } else {
                    body.removeClass('logged-in');
                }
                $timeout(function () {
                    if ($route.current.name === 'wizard') {
                        $('#ng-view').addClass('in-wizard');
                    } else {
                        $('#ng-view').removeClass('in-wizard');
                    }
                    // combined 'background' property doesn't work in Firefox for unknown reason
                    var srcEl = $('#ng-view > div');
                    var mainEl = $('#main-container');
                    _([
                        'image',
                        'position',
                        'size',
                        'repeat',
                        'origin',
                        'clip',
                        'attachment',
                        'color'
                    ]).each(function (prop) {
                        mainEl.css('background-' + prop, srcEl.css('background-' + prop));
                    });
                });
            });
            $scope.$on('$routeChangeError', function (event, current, previous) {
                if (current.$$route.name == 'auth') {
                    routeHelper.redirectTo('dashboard');
                } else {
                    routeHelper.saveRoute();
                    if ($rootScope.doLogout) {
                        $rootScope.$broadcast('$logout', { reason: '$routeChangeError' });
                    }
                }
            });
            $scope.$on('$locationChangeStart', function () {
                if ($location.search().saas_authorized_success) {
                    var authedSaas = $location.search().saas_authorized_success;
                    $location.replace();
                    $location.search(_($location.search()).omit('saas_authorized_success'));
                    $timeout(function () {
                        appConfigurator.watchdogNotice(authedSaas);
                    });
                }
            });
            $scope.$on('$unauthorized', function (event, args) {
                var logoutReason = args && args.reason;
                var logoutMessage = args && args.message;
                if (logoutMessage && logoutMessage.includes('Insufficient privileges')) {
                    modals.alert(logoutMessage, { title: 'Insufficient privileges' });
                    return;
                }
            });
            $scope.$on('$actionfailed', function (event, args) {
                var actFailMessage = args && args.message;
                if (actFailMessage && actFailMessage.startsWith('Action failed!')) {
                    actFailMessage = actFailMessage.replace('Action failed! ', '');
                    modals.alert(actFailMessage, {
                        title: args && args.title || 'Action Failed!',
                        display: 'html'
                    });
                    return;
                }
            });
            $scope.$on('$logout', function (event, args) {
                var logoutReason = args && args.reason;
                console.log('$logout - reason:', logoutReason);
                $rootScope.doLogout = false;
                feature.init(true).then(function () {
                    if (window.location.hostname && window.location.hostname.indexOf('sonicwall') !== -1 && !autologinHelper.noRedirect()) {
                        window.location.href = feature.portalURL || brandInfo.getPortalUrl('sw');
                    } else if (window.location.hostname && window.location.hostname.indexOf('checkpoint') !== -1 && !autologinHelper.noRedirect()) {
                        if (autologinHelper.checkAutologinType() === 'CP') {
                            autologinHelper.isLoggedIn(false);
                        } else {
                            window.location.href = brandInfo.getPortalUrl('cp');
                        }
                    } else {
                        $timeout(function () {
                            routeHelper.redirectTo('auth', { page: 'login' });
                        }, 1000);
                    }
                });
            });
            function copyToClipboard(str) {
                var el = document.createElement('textarea');
                el.value = str;
                el.setAttribute('readonly', '');
                el.style.position = 'absolute';
                el.style.left = '-9999px';
                document.body.appendChild(el);
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);
            }
            $scope.$on('copy-to-clipboard', function (event, args) {
                if (args.data) {
                    copyToClipboard(args.data);
                }
            });
            var maxErrorCount = 10;
            var errorCount = maxErrorCount;
            window.successLogin = function () {
                function checkCurrent() {
                    avananUserDao.current().then(function (response) {
                        if (response.data.hidden) {
                            return routeHelper.restoreRoute();
                        }
                        return configDao.getTrialExpirationDays().then(function (res) {
                            var trialExpirationDays = res.pocExpiresInDays;
                            if (res.deployment_mode === 'demo') {
                                trialExpirationDays = res.demoExpiresInDays;
                            }
                            if (trialExpirationDays < 0) {
                                return trialExpiredModal.show().then(function () {
                                    $rootScope.$broadcast('$logout', { reason: 'trial expired' });
                                });
                            }
                            return routeHelper.restoreRoute();
                        });
                    }, function () {
                        if (errorCount < maxErrorCount) {
                            errorCount++;
                            $timeout(checkCurrent, 500);
                        }
                    });
                }
                if (errorCount < maxErrorCount) {
                    errorCount = 0;
                } else {
                    checkCurrent();
                }
            };
            window.failedLogin = function (queryString) {
                var qs = {};
                if (queryString) {
                    qs = _(queryString.slice(1).split('&')).chain().map(function (element) {
                        var param = element.split('=');
                        return [
                            param[0],
                            decodeURIComponent(param[1] || '')
                        ];
                    }).object().value();
                }
                var msg = qs.email ? 'The user ' + qs.email + ' is not authorized to use this service' : 'You are not authorized to access this service';
                modals.alert(msg, { title: 'Login error' });
            };
            $(window).resize(function () {
                if (Modernizr.mq('(min-width: 768px)') && Modernizr.mq('(max-width: 868px)')) {
                    $('#wrapper').addClass('sidebar-mini').addClass('window-resize');
                    $('.main-menu').find('.openable').removeClass('open');
                    $('.main-menu').find('.submenu').removeAttr('style');
                } else if (Modernizr.mq('(min-width: 869px)')) {
                    if ($('#wrapper').hasClass('window-resize')) {
                        $('#wrapper').removeClass('sidebar-mini window-resize');
                        $('.main-menu').find('.openable').removeClass('open');
                        $('.main-menu').find('.submenu').removeAttr('style');
                    }
                } else {
                    $('#wrapper').removeClass('sidebar-mini window-resize');
                    $('.main-menu').find('.openable').removeClass('open');
                    $('.main-menu').find('.submenu').removeAttr('style');
                }
            });
        }
        if (inIframe()) {
            $rootScope.hideMenu = true;
            $rootScope.runInIframe = true;    // Indicate when TRUE app is running in iframe.
        }
        main();
        iframeMessagingService.sendMessage({ type: 'loaded' });
    }]);
}());